import type { FC, ReactNode } from 'react'
import type { PlanId } from '@/types'

import { cn } from '@/lib/utils'
import { getPlan } from '@/data/plans'

interface PlanBadgeProps {
    plan: PlanId
    className?: string
}

export const PlanBadge: FC<PlanBadgeProps> = ({ plan, className }): ReactNode => {
    const details = getPlan(plan)

    return (
        <span className={cn('inline-flex h-6 items-center gap-1.5 rounded-md border bg-card px-2 text-xs font-medium whitespace-nowrap text-foreground', className)}>
            <span className='size-2 shrink-0 rounded-full' style={{ background: details.color }} aria-hidden='true' />
            {details.name}
        </span>
    )
}
